<script lang="ts" module>
	export interface Badge {
		color: string;
		index: number;
		subIndex?: string;
	}
</script>

<script lang="ts">
	import IconGlobe from 'virtual:icons/material-symbols/language';
	import IconDocument from 'virtual:icons/material-symbols/description';
	interface Props {
		badge: Badge;
		webSource?: boolean;
	}
	let { badge, webSource = false }: Props = $props();
</script>

<div style="background-color: {badge.color};" class="source-badge" class:webSource>
	{#if webSource}
		<IconGlobe />
	{:else}
		<IconDocument />
	{/if}
	<span>
		{badge.index}{badge.subIndex ?? ''}
	</span>
</div>

<style lang="scss">
	@use '@astlai/common/styles/mixins' as lib;

	.source-badge {
		flex: 0 0 auto;
		font-size: 0.875rem;
		padding: 0.25rem 0.375rem 0.25rem 0.25rem;
		border-radius: 0.5rem;
		border-radius: 1rem;
		background: var(--surface-overlay-subtle);
		box-shadow: inset 0 0 0 1px var(--border-subtle);
		@include lib.inline-flex-row();
		@include lib.flex-align();
		gap: 0.25rem;
		font-size: 0.75rem;
		span {
			font-size: 0.75rem;
			line-height: 0.75rem;
		}
	}
</style>
